export default "__VITE_ASSET__CZIzeYcX__"